<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <!-- TABLEAU DIES ACADEMICUS -->
            <div class="row mb-5">
            <div class="col-12">
                <p class="mb-3">Les Dies Academicus approfondissent des thèmes socio-culturels à la lumière de la foi.</p>

                <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead class="table-light">
                    <tr>
                        <th>Dates</th>
                        <th>Thèmes</th>
                        <th>Communicateurs</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in diesAcademicus" :key="index">
                        <td>{{ item.date }}</td>
                        <td>{{ item.theme }}</td>
                        <td>{{ item.communicateur }}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </div>


            <div class="row ">
                <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
                    <div class="blog-card style1">
                        <div class="blog-img"  :style="{height:'277px', backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'}"
                        >
                        </div>
                        <div class="blog-info" style="min-height: 250px;">
                            <ul class="blog-metainfo  list-style">
                                <li><i class="flaticon-user"></i> <router-link to="#">L' École d’Initiation Théologique et Pastorale</router-link></li>
                                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication)  }}</li>
                            </ul>
                            <h3><router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">{{ article.titre }}</router-link></h3>
                            <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }" class="link style1">Lire plus
                                <i class="flaticon-right-arrow"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
    name: 'DiesAcademicus',
    components: {
      PaginationComponent,

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const diesAcademicus = ref([
  {
    date: "04/01/2025",
    theme: "Analyse sociologique du rôle des chrétiens dans le paysage politique béninois / Analyse biblique de l’engagement politique",
    communicateur: "Zinzindohoue Marie-Cécile / Père Roland KPADONOU",
  },
  {
    date: "06/01/2024",
    theme: "La mission de l’Eglise catholique dans l’aujourd’hui : quelques aspects sociaux de sa mission sotériologique / Le défi permanent de l’Eglise : la conversion culturelle",
    communicateur: "Père Raymond GOUDJO, Père Ambroise KINHOUN",
  },
  {
    date: "08/01/2022",
    theme: "Le défi de l’autre / Jésus et la samaritaine : une lecture de Jn 4, 1-43",
    communicateur: "M. Charles Lambert BABADJIDE / Père Hyppolite WHANOU",
  },
  {
    date: "09/01/2021",
    theme: "La sociabilité et la transcendance culturelle : deux finalités éducationnelles pour l’Afrique d’aujourd’hui",
    communicateur: "M. Jean-Claude HOUNMENOU",
  },
  {
    date: "04/01/2020",
    theme: "Construction de notre identité : repères et axes",
    communicateur: "Mme Rolande DEGBOE",
  },
  {
    date: "05/01/2019",
    theme: "L’engagement politique des chrétiens laïcs à la lumière de l’Exhortation apostolique Africae Munus",
    communicateur: "M. Théodore LOKO",
  },
  {
    date: "07/04/2018",
    theme: "Les phénomènes paranormaux à la lumière de la foi chrétienne : entre pathologies religieuses et sociales",
    communicateur: "M. Paul Christian KITI",
  },
]);


    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/31?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    
    onMounted(() => {
        getTreeArticle();
    });

    return {
        diesAcademicus, 
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
</style>